import React, { useEffect } from "react";
import { DatePicker, DatePickerInput, Button, Stack, Select, SelectItem, Tabs, Tab, TabList, TabPanels, TabPanel } from "@carbon/react";
import { CardComponent, CardRow } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card';
import { Calendar } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import { g90, g100 } from '@carbon/themes';
import { useDispatch, useSelector } from 'react-redux'
import { useDatePicker, useSelect } from "../../../components/Inputs/Inputs.hooks";
import { checkErrorRequired } from "../../../modules/errors/validations";
import LoadingContent from "../../../components/Animations/LoadingContent";
import { InputWrapper } from "./AnomaliesVolvo.styles";
import { onGetAnomaliesVolvoThunk } from "./Anomalies.actions";
import VerticalBarChart from '../../../components/Graphs/VerticalBarChart.container'
import { spacing05 } from '@carbon/themes';


const AnomaliesVolvoContainer = () => {
  const dispatch = useDispatch()
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)
  const { error, loading, data, geofenceAnomalies } = useSelector(state => state.anomaliesVolvo)

  const { error: dateError, value: dateValue, onChange: handleDateChange } = useDatePicker({
    initialValue: [yesterday],
    errorCallbacks: [checkErrorRequired()]
  })

  const dispatchAnomaliesVolvo = (date) => {
    handleDateChange(date)
    const currDate = date[0]
    const year = currDate.getFullYear();  // Get the year
    const month = currDate.getMonth() + 1;  // Get the month (0-indexed, so add 1)
    const day = currDate.getDate();  // Get the day of the month
    dispatch(onGetAnomaliesVolvoThunk({ year, month, day }))
  }

  const graphWidth = "100%"
  const graphHeight = "50vh"
  return (
    <>
      <Stack gap={3}>
        <CardComponent width="100%">
          <Card justifyContent='flex-start'>
            <Calendar size={18} />
            <Typography className='cds--type-heading-compact-01'>
              Predicción de anomalías camiones
            </Typography>
          </Card>
          {loading && !error && (
            <LoadingContent />
          )}
          {!loading && error && (
            <>
              <InputWrapper>
                <DatePicker datePickerType="single" maxDate={yesterday.toISOString()} value={dateValue} dateFormat='d-m-Y' onChange={dispatchAnomaliesVolvo}>
                  <DatePickerInput placeholder="dd/mm/yyyy" labelText="Fecha del reporte" id="daily-datepicker" size="md" />
                </DatePicker>
                <CardComponent width="10%">
                  <Typography className='cds--type-heading-compact-01'>
                    No hay datos para este día
                  </Typography>
                </CardComponent>
              </InputWrapper>
            </>
          )}
          {!loading && !error && (
            <Card>
              <Card background={g100.background} width='100%' flexDirection='column' alignItems='left' gap='20px'>
                <InputWrapper>
                  <DatePicker
                    datePickerType="single"
                    maxDate={yesterday.toISOString()}
                    value={dateValue}
                    dateFormat="d-m-Y"
                    onChange={dispatchAnomaliesVolvo}
                  >
                    <DatePickerInput
                      placeholder="dd/mm/yyyy"
                      labelText="Fecha del reporte"
                      id="daily-datepicker"
                      size="md"
                      style={{ width: '15vw' }}
                    />
                  </DatePicker>
                </InputWrapper>
                <CardComponent width="100%">
                  <Card justifyContent='flex-start' >
                    <Typography className='cds--type-heading-compact-01'>
                      Predicción de anomalías camiones
                    </Typography>
                  </Card>
                  <CardRow width='inherit'>
                    <Card flexDirection='column' justifyContent='center' width={graphWidth}>
                      <VerticalBarChart
                        height={graphHeight}
                        title="Anomalías Mantenimiento"
                        data={data}
                        customTooltip={{
                          formatItems: (items) => {
                            return items.map((item) => {
                              // Extract additional properties dynamically
                              const extraData = Object.entries(item.data)
                                .filter(([key]) => !["group", "key", "value", "id"].includes(key)) // Exclude default fields
                                .map(([key, value]) => `${key}: ${value}`); // Format as key-value pairs

                              return {
                                label: item.label, // Keep standard label
                                value: item.value, // Keep value
                                group: `Grupo: ${item.datasetLabel}`, // Add dataset info
                                ...(extraData.length > 0 ? { extra: extraData.join("\n") } : {}), // Add extra data dynamically
                              };
                            });
                          },
                        }}
                      />
                    </Card>
                  </CardRow>
                  <CardRow width='inherit'>
                    <Card flexDirection='column' justifyContent='center' width={graphWidth}>
                      <VerticalBarChart
                        height={graphHeight}
                        title="Anomalías Geocercas"
                        data={geofenceAnomalies}
                        customTooltip={{
                          formatItems: (items) => {
                            return items.map((item) => {
                              // Extract additional properties dynamically
                              const extraData = Object.entries(item.data)
                                .filter(([key]) => !["group", "key", "value", "id"].includes(key)) // Exclude default fields
                                .map(([key, value]) => `${key}: ${value}`); // Format as key-value pairs

                              return {
                                label: item.label, // Keep standard label
                                value: item.value, // Keep value
                                group: `Grupo: ${item.datasetLabel}`, // Add dataset info
                                ...(extraData.length > 0 ? { extra: extraData.join("\n") } : {}), // Add extra data dynamically
                              };
                            });
                          },
                        }}
                      />
                    </Card>
                  </CardRow>
                </CardComponent>
              </Card>
            </Card>
          )}
        </CardComponent>
      </Stack>
    </>
  )
};

export default AnomaliesVolvoContainer;
